import { AddTenantUserRequestSchema, AddTenantUserResponseSchema } from './add-tenant-user.schema';
/**
 * Add Tenant User Endpoint Contract
 * Creates a new user within a specific tenant organization
 * Restricted to super-admin users only
 */ export const addTenantUserContract = {
    method: 'POST',
    path: '/api/v2/tenantuser',
    description: 'Create a new user within a specific tenant organization',
    requestSchema: AddTenantUserRequestSchema,
    responseSchema: AddTenantUserResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=add-tenant-user.contract.js.map